<template>
  <el-dialog 
    width="420px"
    :title="dialog.title" 
    :visible.sync="dialog.isShow"
    @open='open' >
    <el-form ref="form" :model="form" label-width="80px" size="medium">        
      <el-col :span="20">     
        <el-form-item label="名称">          
          <el-input v-model="form.name"></el-input>        
        </el-form-item>      
      </el-col>
      <el-col :span="20">
        <el-form-item
          label="门店"
        >
        <el-input v-model="storeName" readonly placeholder="选择门店">         
          <el-button slot="append" icon="el-icon-search" @click="selectStoreHandle"></el-button>
        </el-input>   
        </el-form-item>
      </el-col>
      
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialog.isShow = false">取 消</el-button>
      <el-button type="primary" @click="Save">保 存</el-button>
    </div>    
    <GetChainStore v-bind:dialogStore="dialogStore" @UpdateSote="UpdateSote"></GetChainStore>
  </el-dialog> 
</template>

<script  type='text/ecmascript-6'>
import GetChainStore from '@/components/GetChainStore'
export default {
  props:{
    dialog:{}
  },
  data (){
    return {
      form : {
      },
      storeName:'',
      dialogStore:{
        isShow:false
      },
    }
  },  
  components:{    
    GetChainStore  
  },
  computed:{
  },
  mounted(){
  },
  methods:{   
    open:function(){      
      console.log("open:"+this.dialog.id)
      var that = this
      this.axios({
        method:'post',
        url:that.global.serverSrc + '/api/booth/Get',         
        data:{
          id: that.dialog.id
        }
      }).then(function (resp) {
        if(resp.data.errorCode==0){
          that.form = resp.data.data
          that.storeName = resp.data.storeName
        }else {
          that.$message.warning(resp.data.message);
        }  
      }).catch(resp => {         
        console.log('请求失败：' + resp.message + ',' + resp.stack)
      })
    },     
    selectStoreHandle:function(){
      this.dialogStore.isShow = true
    },
    UpdateSote:function(id,name){
      this.form.ChainStoreId = id 
      this.storeName = name 
      this.dialogStore.isShow = false
    },
    Save(){
      var that = this
      this.axios({
        method:'post',
        url:that.global.serverSrc + '/api/booth/Save',         
        data:this.form
      }).then(function (resp) {
        if(resp.data.errorCode==0){
          that.$message.success(resp.data.message);
          that.dialog.isShow = false          
          that.$emit('GetData')
        }else {
          that.$message.warning(resp.data.message);
        }  
      }).catch(resp => {         
        console.log('请求失败：' + resp.message + ',' + resp.stack)
      })
    }
  },
  created(){
  
  },
}
</script>